
export const CHANGE_STATE='CHANGE_STATE';
export const CHANGE_MENUE='CHANGE_MENUE';
export const CHANGE_LAYOUT='CHANGE_LAYOUT';
//-----------------------------------------------------
export const IDMAINTARH='IDMAINTARH';
export const CHANGE_IDMAINTARH='CHANGE_IDMAINTARH';
//-----------------------------------------------------
export const NAMETARH='NAMETARH';
export const CHANGE_NAMETARH='CHANGE_NAMETARH';
//-----------------------------------------------------
export const SHOWPAGEHEADER='SHOWPAGEHEADER';
export const CHANGE_SHOWPAGEHEADER='CHANGE_SHOWPAGEHEADER';
//-----------------------------------------------------
export const BACKTOPANEL='BACKTOPANEL';
export const CHANGE_BACKTOPANEL='CHANGE_BACKTOPANEL';
//-----------------------------------------------------
export const NAVITEM='NAVITEM';
export const CHANGE_NAVITEM='CHANGE_NAVITEM';

